// 获取redis的询价格式
import { getDuration } from '../utils';
import _isFunction from 'lodash.isfunction';
const InstanceNetworkTypeMap = {
  '1': 'VPC',
  '0': 'CLASSIC'
};
export default function (config) {
  // console.warn('转换前的数据为', config);
  const orderParamMap = {
    'kvstore_set_pwd': 'kvstore_set_pwd',
    'kvstore_package_type': 'kvstore_package_type',
    'kvstore_vpc_id': 'vpcId',
    'kvstore_vpc_switch_id': 'vSwitchId',
    'orderType': 'orderType',
    'kvstore_capacity': 'Capacity',
    'kvstore_instance_name': 'instanceName',
    'kvstore_region_no': 'regionId',
    'order_num': 'quantity',
    'kvstore_instance_class': 'instanceClass',
    'kvstore_pwd': 'password',
    'kvstore_iz': 'izNo',
    'couponNo': 'couponNo',
    'quantity': 'quantity',
    'kvstore_web_type': 'networkType',
    'chargeType': 'chargeType',
    'kvstore_engineversion_type': 'engineVersion',
    ord_time: val => {
      const v = (val || '').split(':');
      const value = v && v[0];
      const pricingCycle = v && v[1];
      return {
        period: getDuration(value, pricingCycle)
      };
    }
  };
  const goods = config.param.commodities[0];
  const businessInfo = config.param.businessInfo;
  const basicConfig = {
    commodityCode: 'prepaid_kvstore',
    autoPay: 'false',
    orderType: 'BUY',
    chargeType: 'PrePaid'
  };
  const newConfig = {
    ...goods,
    businessInfo: businessInfo
  };
  goods.components.forEach(item => {
    let mapedOrderParam = orderParamMap[item.componentCode];
    if (mapedOrderParam) {
      if (_isFunction(mapedOrderParam)) {
        Object.assign(newConfig, mapedOrderParam.call(null, item.instanceProperty[0].value));
      } else {
        newConfig[mapedOrderParam] = item.instanceProperty[0].value;
      }
    }
  });
  newConfig.networkType = InstanceNetworkTypeMap[newConfig.networkType];
  if (newConfig.networkType == 'CLASSIC') {
    delete newConfig.vpcId;
    delete newConfig.vSwitchId;
  }
  delete newConfig.components;
  delete newConfig.specCode;
  Object.assign(newConfig, basicConfig);
  const outputConfig = {
    items: [{
      commodityCode: config.commodityCode,
      param: JSON.stringify(newConfig)
    }]
  };
  // console.warn(outputConfig);
  return JSON.stringify(outputConfig);
}


// WEBPACK FOOTER //
// ./lib/services/product/kvstore.js